import { render, staticRenderFns } from "./RegisterChild.vue?vue&type=template&id=09c1b2ca"
import script from "./RegisterChild.vue?vue&type=script&lang=js"
export * from "./RegisterChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports